import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import { Card } from './pages/card'
import { Files } from './pages/files'
import { Images } from './pages/images'
import { Poster } from './pages/poster'
import { Videos } from './pages/videos'
import { useCardId, useInitQueryClient, useTrackPage, useWxSetup } from './hooks'
import { ErrorBlock } from 'antd-mobile'
import { MARKETUP, ThemeProvider } from './theme'
import { StateProvider } from './store'
import { useBusinessCard, useCompanyInfo } from './api/query-hooks'
import { QueryClientProvider } from 'react-query'
import { changeFavIcon, changeTheme } from './utils'
import { Preview } from './pages/preview'

const useInit = () => {
  const [theme, setTheme] = useState(MARKETUP)
  const companyInfo = useCompanyInfo()
  useEffect(() => {
    if (companyInfo) {
      setTheme({
        ...theme,
        colors: {
          ...theme.colors,
          theme: companyInfo.themeColor
        }
      })
      changeFavIcon(companyInfo.squareLogo)
      changeTheme(companyInfo.themeColor)
    }
  }, [companyInfo])

  const cardId = useCardId()
  const businessCard = useBusinessCard(cardId)
  return { theme, businessCard }
}

function App() {
  const { theme, businessCard } = useInit()
  useTrackPage()
  useWxSetup(businessCard)
  return (
    <StateProvider businessCard={businessCard}>
      <ThemeProvider theme={theme}>
        <Switch>
          <Route exact={true} path="/">
            <Card />
          </Route>
          <Route path="/files/:menuId">
            <Files />
          </Route>
          <Route path="/images/:menuId">
            <Images />
          </Route>
          <Route path="/videos/:menuId">
            <Videos />
          </Route>
          <Route path="/poster">
            <Poster />
          </Route>
          <Route path="/preview/:assetId">
            <Preview miniProgram={false} />
          </Route>
          <Route path="/previewMini/:assetId">
            <Preview miniProgram={true} />
          </Route>
          <Route path="">
            <Redirect to="/" />
          </Route>
          <Route path="*">
            <ErrorBlock status="empty" />
          </Route>
        </Switch>
      </ThemeProvider>
    </StateProvider>
  )
}

const WrappedApp: React.VFC = () => {
  const client = useInitQueryClient()
  return (
    <QueryClientProvider client={client}>
      <Router basename="/web/business/index">
        <App />
      </Router>
    </QueryClientProvider>
  )
}

export default WrappedApp
